/** Synthesized italic slant (x shear) - identical in preview + export. */
export const ITALIC_SKEW = -0.21;
export function parseHex(c) {
    const m = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec((c ?? '').trim());
    if (!m)
        return null;
    let h = m[1];
    if (h.length === 3)
        h = h.split('').map((x) => x + x).join('');
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}
/** Mix a hex colour toward white (amt>0) or black (amt<0). */
export function shade(c, amt) {
    const rgb = parseHex(c) ?? [217, 165, 32];
    const t = amt >= 0 ? 255 : 0;
    const k = Math.abs(amt);
    const ch = rgb.map((v) => Math.round(v + (t - v) * k));
    return `rgb(${ch[0]},${ch[1]},${ch[2]})`;
}
/** Banded metallic fill for glyphs whose cap band spans [top, bottom]. */
export function metalGradient(ctx, color, top, bottom) {
    const g = ctx.createLinearGradient(0, top, 0, bottom);
    g.addColorStop(0, shade(color, 0.6));
    g.addColorStop(0.38, shade(color, 0.05));
    g.addColorStop(0.5, shade(color, -0.38));
    g.addColorStop(0.62, shade(color, 0.28));
    g.addColorStop(1, shade(color, -0.22));
    return g;
}
/**
 * Blur by shadow: draw the glyphs far off-canvas and let only their (blurred)
 * shadow land in place. Shadow offsets are in DEVICE space, so compute the
 * user-space shift that maps to a pure device-x offset under the current matrix.
 */
export function drawBlurred(c, draw, color, blurPx, frameW) {
    const m = c.getTransform?.();
    const det = m ? m.a * m.d - m.b * m.c : 0;
    if (!m || Math.abs(det) < 1e-9) {
        // No matrix access: approximate with a faded crisp draw.
        c.fillStyle = color;
        c.globalAlpha *= Math.max(0.15, 1 - blurPx / 40);
        draw(0, 0);
        return;
    }
    const OFF = frameW * 4 + 4000;
    // Solve M·u = (-OFF, 0) for the user-space vector u.
    const ux = (m.d * -OFF) / det;
    const uy = (-m.b * -OFF) / det;
    c.shadowColor = color;
    c.shadowBlur = blurPx;
    c.shadowOffsetX = OFF;
    c.shadowOffsetY = 0;
    c.fillStyle = color;
    draw(ux, uy);
}
//# sourceMappingURL=paint.js.map